

















import DateRangePickerMixin from './DateRangePickerMixin';
import { QInputElement } from '../types';

export default DateRangePickerMixin.extend({
  props: {
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    reset(): void {
      this.clear();
      this.$emit('clear', null);
    },
    blur(): void {
      (this.$refs.input as QInputElement).blur();
    },
  },
  mounted() {
    if (this.flatpickr) {
      // @ts-ignore
      this.flatpickr.set('onClose', this.blur);
    }
  },
});
